var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterAlign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCCCD9",
    d: "M5.88889 5.93433H18.1111C18.602 5.93433 19 6.3323 19 6.82322V7.04544C19 7.53636 18.602 7.93433 18.1111 7.93433H5.88889C5.39797 7.93433 5 7.53636 5 7.04544V6.82322C5 6.3323 5.39797 5.93433 5.88889 5.93433ZM8.74314 10.9343H15.2569C15.7478 10.9343 16.1457 11.3323 16.1457 11.8232V12.0454C16.1457 12.5364 15.7478 12.9343 15.2569 12.9343H8.74314C8.25222 12.9343 7.85425 12.5364 7.85425 12.0454V11.8232C7.85425 11.3323 8.25222 10.9343 8.74314 10.9343ZM5.88889 15.9343H18.1111C18.602 15.9343 19 16.3323 19 16.8232V17.0454C19 17.5364 18.602 17.9343 18.1111 17.9343H5.88889C5.39797 17.9343 5 17.5364 5 17.0454V16.8232C5 16.3323 5.39797 15.9343 5.88889 15.9343Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlign);
export default __webpack_public_path__ + "static/media/center-align.b2efab1a88c9116cead476015d1181e9.svg";
export { ForwardRef as ReactComponent };